"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Schema for DTO
 * Schema for DTO
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfApiPostWorkflowRequest = instanceOfApiPostWorkflowRequest;
exports.ApiPostWorkflowRequestFromJSON = ApiPostWorkflowRequestFromJSON;
exports.ApiPostWorkflowRequestFromJSONTyped = ApiPostWorkflowRequestFromJSONTyped;
exports.ApiPostWorkflowRequestToJSON = ApiPostWorkflowRequestToJSON;
exports.ApiPostWorkflowRequestToJSONTyped = ApiPostWorkflowRequestToJSONTyped;
/**
 * Check if a given object implements the ApiPostWorkflowRequest interface.
 */
function instanceOfApiPostWorkflowRequest(value) {
    if (!('values' in value) || value['values'] === undefined)
        return false;
    return true;
}
function ApiPostWorkflowRequestFromJSON(json) {
    return ApiPostWorkflowRequestFromJSONTyped(json, false);
}
function ApiPostWorkflowRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'values': json['values'],
        'tenantId': json['tenant_id'] == null ? undefined : json['tenant_id'],
    };
}
function ApiPostWorkflowRequestToJSON(json) {
    return ApiPostWorkflowRequestToJSONTyped(json, false);
}
function ApiPostWorkflowRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'values': value['values'],
        'tenant_id': value['tenantId'],
    };
}
